import { handleActions } from '@housinganywhere/safe-redux';

import { Actions, ActionTypes } from '../actions/getCounts';
import { CityListingsCountsMap } from '../types';

interface State {
  counts: CityListingsCountsMap;
  error: boolean;
}

export const initialState: State = {
  counts: {},
  error: false,
};

export default handleActions<State, ActionTypes, Actions>(
  {
    [ActionTypes.START]: state => ({
      ...state,
      error: false,
    }),
    [ActionTypes.DONE]: (state, { payload }) => ({
      ...state,
      counts: { ...state.counts, ...payload },
    }),
    [ActionTypes.FAIL]: state => ({
      ...state,
      error: true,
    }),
  },
  initialState,
);
